import LocationName from './LocationName';
export default LocationName;
